import { render, staticRenderFns } from "./ArchivedRoles.vue?vue&type=template&id=a81b3b66&scoped=true&"
import script from "./ArchivedRoles.vue?vue&type=script&lang=js&"
export * from "./ArchivedRoles.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedRoles.vue?vue&type=style&index=0&id=a81b3b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81b3b66",
  null
  
)

export default component.exports